// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"6f01addb","849":"c23315c4"}[chunkId] + ".js";
};